import { httpRequest } from "@/lib";
import { RequestTenant, TenantResponse } from "@/types";
import { useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

export async function useRequestTenantId({
  code,
}: RequestTenant): Promise<TenantResponse> {
  const response = await httpRequest.get<TenantResponse>(
    `/tenants/get-by-code/${code}`
  );
  return response.data;
}

export function useRequestTenantIdMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: useRequestTenantId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tenant"] });
    },
  });
}
